import React, { useEffect, useState } from "react";
import Crane from "../../../Assets/crane/Crane.jpg";
import mechanicImg1 from "../../../Assets/crane/mechanicImg1.png";
import RecoveryVan1 from "../../../Assets/crane/RecoveryVan1.png";
// import lawyer from "../../../Assets/crane/lawyer.jpg";
import Navbar from "../../../Component/Home/Navbar";
import logo from "../../../Assets/footer/logo.svg";
import Fb from "../../../Assets/footer/Fb.svg";
import Insta from "../../../Assets/footer/Insta.svg";
import LinkedIn from "../../../Assets/footer/LinkedIn.svg";
import Youtube from "../../../Assets/footer/Youtube.svg";
import img3 from "../../../Assets/home/img3.png";
import Workshop from "../../../Assets/home/Workshop.jpg";


const services = [
  {
    title: "Crane Services",
    status: "Live",
    description:
      "Premier Crane & Hydra Services – Swift, Safe & Tech-Driven.",                                  
    details:
      "ClaimPro Assist delivers industry-leading crane and hydra services tailored for commercial vehicles—trucks, buses, heavy-duty rigs—across India. As India’s first tech-powered platform for accident and breakdown support, we combine speed, safety, and precision in every operation. When a commercial vehicle meets with an accident, breakdown, or gets stranded off-road, our Tech‑enabled cranes and certified operators are dispatched instantly through our smart-matching algorithm. Expect fast response, transparent billing, and complete digital documentation—right from task allocation to completion.",
    image: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/Crane.jpg',
  },
  {
    title: "Recovery Vans",
    status: "Live",
    description:
      "Recovery Van - On-Demand Recovery Van Services – Quick, Dependable & Digitally Enabled.",
    details:
      "ClaimPro Assist offers fast, tech-driven recovery van services for accidental or immobile vehicles across India. Whether it's a car, van, or light commercial vehicle, our recovery vans are equipped to safely tow your vehicle to the nearest garage, service center, or destination of your choice. Using our digital platform, field teams are assigned in real-time based on location, ensuring the nearest recovery van reaches you without delay. Every job is tracked live, geo-tagged, and fully documented—providing transparency and peace of mind from start to finish.",
    image: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/RecoveryVan1.png',
  },
  {
    title: "Advocate",
    status: "Coming Soon...",
    description:
      "Advocate - Advocate Support Services- Legal Help When You Need It Most.",
    details:
      "ClaimPro Assist offers specialized advocate services to help vehicle owners and transporters navigate legal challenges after accidents or enforcement actions. Whether your vehicle is seized or your driver is detained, our legal experts step in quickly to assist with release formalities and court procedures. We connect you with experienced advocates who are well-versed in Motor Vehicle Acts, accident claims, challans, FIRs, and police station formalities—ensuring swift action to minimize disruptions to your operations.",
    image: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/img3.png',
  },
  {
    title: "Mechanics",
    status: "Coming Soon...",
    description:
      "Mechanics - Onsite Mechanic Services – Expert Repairs at Your Breakdown Spot.",
    details:
      "ClaimPro Assist offers 24x7 onsite mechanic support for minor repairs, breakdown fixes, and roadside diagnostics—wherever your vehicle stops, we start the solution. From battery jumpstarts and fuel delivery to clutch wire repairs and minor engine fixes, our mobile mechanics bring the workshop to you. Once you raise a request, our smart dispatch system locates and assigns the nearest verified technician. With real-time tracking, digital service logs, and upfront pricing, ClaimPro Assist ensures complete visibility and zero guesswork.",
    image: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mechanicImg1.png',
  },
  {
    title: "Workshops",
    status: "Coming Soon...",
    description:
      "Garage/Workshop Services - for Commercial Vehicles - Trusted Repairs.",
    details:
      "ClaimPro Assist connects you to a pan-India network of verified garages specializing in commercial vehicle repairs and maintenance. Whether it's accident damage, mechanical failure, or periodic servicing, we ensure your trucks, buses, or heavy-duty vehicles get expert attention with zero downtime. Our platform identifies the nearest trusted garage partner, manages digital job cards, tracks repair progress in real time, and provides instant invoicing. From towing to repair to claim support, we handle every step—so your fleet stays on the move.",
    image: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home/Workshop.jpg',
  },
];

export default function ServiceShowPage() {

    useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    
    scrollToTop();
    
    const timeoutId = setTimeout(() => {
      scrollToTop();
    }, 100);
    
    return () => clearTimeout(timeoutId);
  }, []);

  const [modalData, setModalData] = useState(null);
  
  return (
    <div className="font-satoshi min-h-screen bg-white">
      <Navbar />
      {/* <header className="bg-[#21A6E9] text-white p-2 shadow-md z-40 font-satoshi">
        <h1 className="text-2xl font-bold text-center">Our Services</h1>
      </header> */}
      <div className="md:px-[5%] px-[5%]  font-satoshi">
        <div className="pb-2 pt-[2rem] px-0"> 
               <button
             
              className="bg-[#ffffff] hover:bg-[#21A6E9] items-center border border-[#21A6E93D] text-[#21A6E9] hover:text-[#FFFFFF] py-[12px] px-[24px] uppercase rounded-full font-satoshi font-[400] text-[18px] leading-[26px] ease-in transition-all"
            >
              Services
            </button></div>

      

      <main className="max-w-6xl mx-auto  px-4 text-center">
       
         
                <h6 className="max-w-full w-full font-satoshi font-[500] text-[#1B2E3F] text-[6vw] sm:text-[5vw] md:text-[2vw] leading-snug pb-[20px]">
                  Driven to Respond. Powered to Assist
                </h6>

        <div> 
          {/* Grid for first 3 items */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 items-center justify-center font-satoshi pb-4">
            {services.map((service, index) => (
              <div
                key={index}
                // className="flex flex-col bg-white rounded-xl shadow-md p-4 border-l-4 border-transparent transition-all min-h-[420px] text-left"
                className={`flex flex-col bg-white rounded-xl shadow-md p-4 border-l-4 transition-all h-[460px] text-left ${
                  modalData?.title === service.title
                    ? "border-[#21A6E9] shadow-lg"
                    : "border-transparent"
                }`}
              >
                <div className="h-[180px] w-full mb-4 overflow-hidden rounded-md">
                <img
                  src={service.image}
                  alt={service.title}
                  className="h-30 w-full object-cover rounded-md mb-4"
                />
                </div>
                <div className="flex items-center justify-between mb-1 font-satoshi">
                  <h3 className="text-[20px] font-bold py-2 text-[#21A6E9]">
                    {service.title}
                  </h3>
                  <span
                    className={`text-[17px] font-semibold px-3 py-1 rounded-full ${
                      service.status === "Live"
                        ? "bg-green-400 text-black"
                        : "bg-yellow-200 text-black"
                    }`}
                  >
                    {service.status}
                  </span>
                </div>

                <p className="text-[18px] leading-normal py-1 font-satoshi text-black">
                  {service.description}
                </p>

                <div className="mt-auto pt-4">
                  <button
                    className="bg-[#21A6E9] text-white px-4 py-2 rounded-full font-satoshi text-[17] font-[400]"
                    onClick={() => setModalData(service)}
                  >
                    MORE
                  </button>
                </div>
              </div>
            ))}
          </div>

     
        </div>

        {modalData && (
          <div className="absolute inset-0 min-h-screen z-50 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-start overflow-y-auto md:px-[5%] px-[5%] md:py-[4rem] py-[2rem] mt-12">
            <div className="bg-white rounded-xl shadow-lg w-full max-w-[680px] p-4 relative font-satoshi text-black overflow-hidden">
              {/* Close button */}
              <button
                className="absolute top-2 right-3 text-xl font-bold text-gray-600 hover:text-red-500"
                onClick={() => setModalData(null)}
              >
                ×
              </button>

              {/* Title */}
              <h2 className="text-xl leading-normal font-bold text-[#21A6E9] mb-2 sm:mb-4 break-words text-center sm:text-left">
                {modalData.title}
              </h2>

              {/* Top part: image and preview */}
              <div className="flex flex-col sm:flex-row-reverse gap-4">
                {/* Image */}
                <div className="flex-shrink-0 w-full sm:w-[220px] sm:h-[160px]">
                  <img
                    src={modalData.image}
                    alt={modalData.title}
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>

                {/* Description + preview lines */}
                <div className="flex-1 text-[18px] self-start">
                  <p className="font-bold mb-2 leading-relaxed text-[20px]  text-left break-words whitespace-pre-line">
                    {modalData.description}
                  </p>
                  <p className="text-[16px]  leading-normal break-words whitespace-pre-line text-left">
                    {modalData.details?.slice(0, 200)}
                  </p>
                </div>
              </div>

              {/* Bottom part: remaining text */}
              {modalData.details?.length > 200 && (
                <div className=" text-[16px] leading-normal whitespace-pre-line break-words text-left">
                  {modalData.details.slice(180)}
                </div>
              )}
            </div>
          </div>
        )}
      </main></div>
        <div className="bg-[#E5F6FF]  py-2 px-4 md:px-12 flex flex-col md:flex-row justify-between items-center md:items-start font-satoshi">
                   {/* Left: Logo and Name */}
                   <div className="flex items-center gap-2 mt-2 mb-1 md:mb-0 flex-nowrap">
                     <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/logo.svg' alt="ClaimPro Assist Logo" className="h-12" />
                     <p className=" font-satoshi text-[18px] leading-[32px] text-[#0A0119] mb-0 whitespace-nowrap">
                       © 2025 BCV ClaimPro Assist Private Limited.
                     </p>
                   </div>
           
                   {/* Right: Social Links */}
                   <div className="text-right font-satoshi">
                     <p className="text-[18px] mr-2 mb-1">Follow us on</p>
                     <div className="flex gap-2 items-end">
                       <a
                         href="https://www.facebook.com/p/BVC-ClaimPro-Assist-61559865797607/"
                         target="_blank"
                         rel="noopener noreferrer"
                       >
                         <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Fb.svg' alt="Facebook" className="h-6 w-6" />
                       </a>
                       <a
                         href="https://www.instagram.com/bvc_claimpro_assist_official/"
                         target="_blank"
                         rel="noopener noreferrer"
                       >
                         <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Insta.svg' alt="Instagram" className="h-6 w-6" />
                       </a>
                       <a
                         href="https://in.linkedin.com/company/bvc-claim-pro-assist"
                         target="_blank"
                         rel="noopener noreferrer"
                       >
                         <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/LinkedIn.svg' alt="LinkedIn" className="h-6 w-6" />
                       </a>
                       <a
                         href="https://www.youtube.com/watch?v=qmUlSNG5xKg"
                         target="_blank"
                         rel="noopener noreferrer"
                       >
                         <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Youtube.svg' alt="YouTube" className="h-6 w-6" />
                       </a>
                     </div>
                   </div>
                 </div>
    
    </div>
  );
}
